// @ts-nocheck
import { useEffect, useState } from 'react'
import { gql } from '@apollo/client'
import { useMutation, useQuery } from '@apollo/client/react'
import { DragDropContext } from '@hello-pangea/dnd'
import findByKeyValue from 'helpers/findByKeyValue'

import Card from 'js/components/Card'

import Item from './components/Item'
import List from './components/List'
import styles from './TextPageNav.module.css'

const TextPageNav = ({ guid, editMode }) => {
    const [menu, setMenu] = useState()
    const [mutate] = useMutation<any>(SUB_NAV_REORDER)
    const { data, loading } = useQuery<any>(GET_SUB_NAV, {
        variables: { guid },
        fetchPolicy: 'cache-and-network',
    })

    useEffect(() => {
        if (data?.entity) {
            setMenu(data.entity.menu)
        }
    }, [data, setMenu])

    if (loading || !menu) {
        return null
    }

    const handleDragEnd = (result) => {
        const { source, destination } = result
        if (!destination || destination.index === source.index) {
            return
        }

        const listId = result.type

        const sourcePosition = result.source.index
        const destinationPosition = result.destination.index

        const newMenu = JSON.parse(JSON.stringify(menu))

        const children = [...findByKeyValue(newMenu, 'guid', listId).children]

        const [movedItem] = children.splice(sourcePosition, 1)
        children.splice(destinationPosition, 0, movedItem)

        const update = (guid, children) => (obj) => {
            if (obj.guid === guid) {
                if (obj.children) {
                    obj.children = children
                }
                return true
            } else if (obj.children) {
                return obj.children.some(update(guid, children))
            }
        }

        const newMenuArray = [newMenu]
        newMenuArray.some(update(listId, children))

        setMenu(newMenu)

        mutate({
            variables: {
                input: {
                    guid: result.draggableId,
                    sourcePosition: source.index,
                    destinationPosition: destination.index,
                },
            },
        })
    }

    return (
        <Card as="ul" className={styles.wrapper}>
            <li>
                <Item item={menu} editMode={editMode} depth={0} />
                <DragDropContext onDragEnd={handleDragEnd}>
                    <List
                        containerGuid={menu.guid}
                        items={menu.children}
                        depth={1}
                        editMode={editMode}
                    />
                </DragDropContext>
            </li>
        </Card>
    )
}

const GET_SUB_NAV = gql`
    query SubNav($guid: String!) {
        entity(guid: $guid) {
            guid
            ... on Page {
                title
                url
                menu {
                    guid
                    title
                    localTitle
                    link
                    children {
                        guid
                        title
                        localTitle
                        link
                        children {
                            guid
                            title
                            localTitle
                            link
                            children {
                                guid
                                title
                                localTitle
                                link
                            }
                        }
                    }
                }
            }
        }
    }
`

const SUB_NAV_REORDER = gql`
    mutation SubNavReorder($input: reorderInput!) {
        reorder(input: $input) {
            container {
                guid
                ... on Page {
                    menu {
                        guid
                        title
                        link
                        children {
                            guid
                            title
                            link
                            children {
                                guid
                                title
                                link
                                children {
                                    guid
                                    title
                                    link
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`

export default TextPageNav
